import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "./ui/carousel";
import { Star, Quote } from "lucide-react";
import Reveal from "./Reveal";

const TESTIMONIALS = [
  {
    name: "Marcus & Diane Bell",
    location: "Houston, TX",
    recovered: "$47,000",
    quote: "We had no idea any money was owed to us after losing our home. American Asset Recovery walked us through everything and recovered $47,000 we never knew existed.",
    img: "https://images.unsplash.com/photo-1553009338-80e505b3f61b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxoYXBweSUyMGRpdmVyc2UlMjBwZW9wbGUlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODI3NDk3MDh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Lisa Ortega",
    location: "Phoenix, AZ",
    recovered: "$18,500",
    quote: "Honest, kind, and zero pressure. They handled every court filing and stayed in touch the whole way. The check arrived just like they said it would.",
    img: "https://images.unsplash.com/photo-1758272134088-d3d58d939d12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxoYXBweSUyMGRpdmVyc2UlMjBwZW9wbGUlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODI3NDk3MDh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Robert Hannigan",
    location: "Cleveland, OH",
    recovered: "$22,300",
    quote: "I almost threw away the letter, thinking it was a scam. I'm so glad I called. Within four months they had recovered over $22,000 for my family.",
    img: "https://images.unsplash.com/photo-1698047682091-782b1e5c6536?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHx3YXJtJTIwd2VsY29taW5nJTIwcHJvZmVzc2lvbmFsJTIwaGFuZHNoYWtlJTIwb2ZmaWNlfGVufDB8fHx8MTc4Mjc0OTcwN3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Janelle Whitmore",
    location: "Atlanta, GA",
    recovered: "$61,800",
    quote: "After my divorce I assumed the foreclosure was the end of the chapter. This team uncovered $61,800 in surplus funds that became the start of rebuilding my life.",
    img: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&q=80",
  },
  {
    name: "Carlos Mendez",
    location: "Miami, FL",
    recovered: "$34,200",
    quote: "Bilingual, patient, and incredibly thorough. They explained every step in plain language. I would recommend them to anyone facing this situation.",
    img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&q=80",
  },
  {
    name: "Priya & Sanjay Rao",
    location: "Sacramento, CA",
    recovered: "$29,000",
    quote: "We were skeptical at first — too many scams out there. Their transparency, no upfront fees, and clear contract won us over. The recovery came through six months later.",
    img: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=400&q=80",
  },
  {
    name: "Mary Catherine O'Brien",
    location: "Pittsburgh, PA",
    recovered: "$15,400",
    quote: "After my husband passed, the foreclosure paperwork was overwhelming. They handled everything with such compassion and recovered money I didn't even know we had a right to.",
    img: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&q=80",
  },
  {
    name: "Devon Carter",
    location: "Detroit, MI",
    recovered: "$41,700",
    quote: "Fast, professional, no nonsense. They found the surplus, filed the petition, and got the check released in under five months. Easiest decision I made all year.",
    img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-20 sm:py-24 lg:py-32 bg-[#EFEAE0]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal>
          <div className="max-w-2xl mb-12">
            <p className="text-sm sm:text-base font-bold uppercase tracking-[0.18em] text-[#FF008F] mb-4">Real Recoveries</p>
            <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#0F172A] leading-tight">
              Families who got their money back.
            </h2>
            <p className="mt-4 text-[#475569]">Real clients, real recoveries. Swipe through their stories.</p>
          </div>
        </Reveal>

        {/* Wide family banner */}
        <Reveal delay={0.05}>
          <div className="relative rounded-3xl overflow-hidden border border-[#E2DDD3] shadow-2xl shadow-[#0F172A]/10 mb-12 aspect-[21/9] sm:aspect-[21/8]">
            <img
              src="https://images.unsplash.com/photo-1609220136736-443140cffec6?crop=entropy&cs=srgb&fm=jpg&w=1920&h=720&fit=crop&q=80"
              alt="A happy family enjoying time together — the families American Asset Recovery Agency helps recover funds for"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0F172A]/75 via-[#0F172A]/30 to-transparent" />
            <div className="absolute inset-0 flex items-center">
              <div className="px-6 sm:px-10 lg:px-14 max-w-xl text-[#F7F5F0]">
                <p className="text-sm sm:text-base font-bold uppercase tracking-[0.18em] text-[#FF008F] mb-3">$14M+ recovered</p>
                <p className="font-serif-display text-2xl sm:text-3xl lg:text-4xl leading-tight">
                  Every check we deliver helps a family take their next step forward.
                </p>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <Carousel opts={{ align: "start", loop: true }} className="w-full" data-testid="testimonials-carousel">
            <CarouselContent className="-ml-4">
              {TESTIMONIALS.map((t, i) => (
                <CarouselItem key={t.name} className="pl-4 sm:basis-1/2 lg:basis-1/3">
                  <article
                    className="h-full bg-white rounded-2xl border border-[#E2DDD3] shadow-sm p-7 flex flex-col"
                    data-testid={`testimonial-${i}`}
                  >
                    <div className="flex items-center justify-between mb-4">
                      <div className="flex gap-1 text-[#FF008F]">
                        {[...Array(5)].map((_, n) => <Star key={n} className="w-4 h-4 fill-current" />)}
                      </div>
                      <Quote className="w-6 h-6 text-[#1E3A8A]/30" />
                    </div>

                    <p className="text-[#0F172A] leading-relaxed font-serif-display text-lg flex-1">
                      "{t.quote}"
                    </p>

                    <div className="mt-6 pt-5 border-t border-[#E2DDD3] flex items-center gap-3">
                      <img
                        src={t.img}
                        alt={t.name}
                        loading="lazy"
                        className="w-12 h-12 rounded-full object-cover ring-2 ring-[#FFE5F2]"
                      />
                      <div className="flex-1 min-w-0">
                        <p className="text-sm text-[#0F172A] font-medium truncate">{t.name}</p>
                        <p className="text-xs text-[#64748B]">{t.location}</p>
                      </div>
                      <div className="text-right">
                        <p className="text-[10px] uppercase tracking-wider text-[#64748B]">Recovered</p>
                        <p className="font-serif-display font-bold text-xl text-[#FF008F]">{t.recovered}</p>
                      </div>
                    </div>
                  </article>
                </CarouselItem>
              ))}
            </CarouselContent>

            <div className="hidden sm:block">
              <CarouselPrevious
                data-testid="testimonials-prev"
                className="-left-4 lg:-left-12 bg-white border-[#E2DDD3] hover:bg-[#FF008F] hover:text-white hover:border-[#FF008F]"
              />
              <CarouselNext
                data-testid="testimonials-next"
                className="-right-4 lg:-right-12 bg-white border-[#E2DDD3] hover:bg-[#FF008F] hover:text-white hover:border-[#FF008F]"
              />
            </div>
          </Carousel>
        </Reveal>

        <p className="text-center text-xs text-[#64748B] mt-8 sm:hidden">Swipe to see more →</p>
      </div>
    </section>
  );
}
